module.exports = __webpack_public_path__ + "static/media/js.dd60b11e.svg";